import { configureStore } from '@reduxjs/toolkit'
import authReducer from "./slices/auth";
import messageReducer from "./slices/message";
import categoryReducer from "./slices/category"
import quoteReducer from "./slices/quote"

const reducer = {
  auth: authReducer,
  message: messageReducer,
  category: categoryReducer,
  quote: quoteReducer
}

const store = configureStore({
  reducer: reducer,
  devTools: true,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false
  })
})

export default store;